import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import './styles/autocomplete.scss';

const Autocomplete = ({ suggestions, onSelect, onClose }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const onKeyDown = (event) => {
    if (!suggestions.length) { return undefined; }
    let index = selectedIndex;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        if (selectedIndex === null) {
          index = 0;
        } else {
          index = selectedIndex === suggestions.length - 1 ? 0 : selectedIndex + 1;
        }
        setSelectedIndex(index);
        break;
      case 'ArrowUp':
        event.preventDefault();
        if (selectedIndex === null) {
          index = suggestions.length - 1;
        } else {
          index = selectedIndex === 0 ? suggestions.length - 1 : selectedIndex - 1;
        }
        setSelectedIndex(index);
        break;
      case 'Enter':
        if (suggestions[selectedIndex]) {
          onSelect(suggestions[selectedIndex].value);
        }
        break;
      case 'Escape':
        onClose();
        break;
      default:
        break;
    }

    return undefined;
  };

  useEffect(() => {
    window.addEventListener('keydown', onKeyDown);

    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, []);

  if (!suggestions.length) { return null; }

  const suggestionEls = suggestions.map(({ label, value }, index) => (
    <li
      key={label}
      className={index === selectedIndex ? 'selected' : null}
    >
      <button
        type="button"
        onClick={() => onSelect(value)}
        onMouseOver={() => setSelectedIndex(index)}
        onFocus={() => setSelectedIndex(index)}
      >
        {label}
      </button>
    </li>
  ));

  return (
    <ul
      className="search-autocomplete"
      onMouseLeave={() => setSelectedIndex(null)}
    >
      {suggestionEls}
    </ul>
  );
};

Autocomplete.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  onSelect: PropTypes.func,
  onClose: PropTypes.func,
};

Autocomplete.defaultProps = {
  suggestions: [],
  onSelect: () => {},
  onClose: () => {},
};

export default Autocomplete;
